// @flow

import { Shop } from './Shop'

// @deprecated
export const FacebookPage = Shop
